module.exports = __webpack_public_path__ + "static/assets/1fb9ffd71d73f3f3c5f10027d14da9f1.png";